<template>
  <div>
    <el-button
      type="primary"
      @click="$message.warning('功能暂未开放')"
      style="margin-right: 1rem"
      >预览</el-button
    >
    <el-button type="primary" @click="savePage">保存报考指南</el-button>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  methods: {
    //保存
    savePage() {
      // console.log("点击了保存11");
      this.$emit("savePage");
    },
  },
  watch: {},
  created() {
    /* this.getCampusList();
    this.getPageList(); */
  },
  mounted() {
    /*  window.onresize = () => {
      this.setaddDialogwidth();
    }; */
  },
};
</script>
<style scoped>
</style>



// WEBPACK FOOTER //
// src/components/addGuide/components/Confirm.vue